module.exports = __webpack_public_path__ + "static/img/afmLocation.c7390e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afmLocation.png
// module id = J+HI
// module chunks = 1